@if (profileFields(); as fields) {
  <plugins-multi-select
    [color]="baseColor"
    [formControl]="control"
    [options]="profileFieldsOptions()"
    [selectedOptionsFormat]="selectedOptionsFormat"
    [maxSelected]="maxSelected()"
  >
    <ng-template
      [pluginsMultiSelectOption]="profileFieldsOptions()"
      let-option
      let-disabled="disabled"
      let-index="index"
    >
      <div class="profile-field" [class.disabled]="disabled">
        <span class="field-key">{{ fields[index].key }}</span>
        @if (fields[index].value !== undefined) {
          <span class="field-value">{{ fields[index].value }}</span>
        }
      </div>
    </ng-template>
  </plugins-multi-select>
} @else {
  <icon-spinner
    class="mr-2"
    animation="spin duration-400ms iterate-infinite"
    [size]="18"
  />
}
